export const dashboardActionTypes = {
  SET_APPOINTMENTS: 'SET_APPOINTMENTS',
  SET_UPCOMING_APPOINTMENTS: 'SET_UPCOMING_APPOINTMENTS',
  UPDATE_SINGLE_APPOINTMENT: 'UPDATE_SINGLE_APPOINTMENT'
};
